import { SimpleTable, TableActions } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { useReduxLoading, useReduxMessage } from '@core/hooks';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatPercentual } from '@format';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { ImpostoAction } from '../../store/impostoAction';
import { useImposto } from '../../store/impostoContext';

function ImpostoTable({ onTour, onFetchData }) {
  const [state, dispatch] = useImposto();

  useReduxMessage(state.mensagem);
  useReduxLoading(state.carregandoRegistro);

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'excluir',
      tooltip: 'Excluir',
      show:
        permissaoUtils.imposto().excluir &&
        (state.tipoSelecao === 'TODOS_FILTRO' || (state.selecionados && state.selecionados.length > 0)),
      onClick: () => {
        ImpostoAction.removerRegistros(
          dispatch,
          state.selecionados,
          state.tipoSelecao === 'TODOS_FILTRO' ? state.requestParams : null
        );
      },
    },
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.imposto().cadastrar,
      onClick: () => dispatch(ImpostoAction.setCadastrarRegistro()),
    },
  ];

  const columns = [
    {
      name: 'nome',
      title: 'Nome do imposto',
      sortingEnabled: true,
    },
    {
      name: 'fornecedor.pessoa.nome',
      title: 'Fornecedor',
      getCellValue: (value) => value?.fornecedor?.pessoa?.nome || '',
      sortingEnabled: true,
    },
    {
      name: 'codigo',
      title: 'Código do imposto',
      hideTooltip: true,
      align: 'center',
      sortingEnabled: true,
    },
    {
      name: 'aliquota',
      title: 'Alíquota (%)',
      hideTooltip: true,
      align: 'center',
      getCellValue: (value) => {
        return formatPercentual(value?.aliquota);
      },
      sortingEnabled: true,
    },
    {
      name: 'tipo',
      title: 'Tipo do imposto',
      hideTooltip: true,
      getCellValue: (value) => {
        const map = {
          OUTROS: 'Outros impostos',
          IBSCBS: 'Guia Nacional IBS/CBS',
        };

        const tipo = value?.tipo?.toUpperCase();
        return map[tipo] ?? value?.tipo ?? '-';
      },
      sortingEnabled: true,
    },
    {
      sortingEnabled: false,
      width: 125,
      align: 'left',
      getCellValue: (imposto) => (
        <>
          <TableActionContainer onTour={onTour}>
            {permissaoUtils.imposto().editar && (
              <TableActionButtonEdit
                className={'stepIconeEditar'}
                onClick={() => {
                  ImpostoAction.editarRegistro(dispatch, imposto);
                }}
              />
            )}

            {permissaoUtils.imposto().excluir && (
              <TableActionButtonDelete
                className={'stepIconeExcluir'}
                onClick={() =>
                  ImpostoAction.removerRegistros(dispatch, [imposto], { ...state.requestParams, tipoSelecao: 'NENHUM' })
                }
              />
            )}
          </TableActionContainer>
        </>
      ),
    },
  ];

  return (
    <>
      <SimpleTable
        defaultSorting={[{ columnName: 'nome', direction: 'asc' }]}
        columns={columns}
        fetchData={onFetchData}
        // fetchOnCreate
        rows={state.page.content}
        totalCount={state.page.totalElements}
        searchBy={state.requestParams.q}
        loading={state.carregandoRegistros}
        selection={state.selecionados}
        onSelectionChange={(params) => dispatch(ImpostoAction.setSelecionados(params))}
        selectionType={state.tipoSelecao}
        onSelectionTypeChange={(params) => {
          dispatch(ImpostoAction.setTipoSelecao(params));
        }}
        onRowClick={(params) => ImpostoAction.visualizarRegistro(dispatch, params)}
        onCurrentPageChange={(params) => dispatch(ImpostoAction.setCurrentPage(params))}
        onPageSizeChange={(params) => dispatch(ImpostoAction.setPageSize(params))}
        onSortingChange={(params) => dispatch(ImpostoAction.setSorting(params))}
      />
      {(permissaoUtils.imposto().cadastrar || permissaoUtils.imposto().excluir) && (
        <TableActions className={'stepPlusButton'} actions={actions} />
      )}
    </>
  );
}

export default ImpostoTable;
